import {inject, Injectable} from '@angular/core';
import {ProjectService, WmHttpService} from "@wms/services";
import {HttpClient} from "@angular/common/http";
import { runtimeEventManager } from "@wm/core";
import { environment } from "@wms/app";
import { get } from "lodash-es";

@Injectable({
  providedIn: 'root'
})
export class PageService {

  private TARGET: string = 'PAGE';
  private API_META: any = {
    create: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/pages/:pageName",
      method: "POST"
    },
    duplicate: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/pages/:pageName/duplicate",
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      }
    },
    rename: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/pages/:pageName/rename",
      method: "PUT",
      headers: {
        'Content-Type': 'application/json'
      }
    },
    update: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/pages/:pageName/metadata",
      method: "PUT"
    },
    list: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/pages",
      method: "GET"
    },
    remove: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/pages/:pageName",
      method: "DELETE"
    }
  };

  // to cache pages list
  public pages: any = [];
  public activePageName: string;

  constructor(private wmHttpService: WmHttpService, private projectService: ProjectService, private http: HttpClient) {
    wmHttpService.registerApiMeta(this.TARGET, this.API_META);
    runtimeEventManager.setService('fetchContent', this.fetchContent.bind(this));
  }

  create(params: any) {
    return(this.wmHttpService.execute({
      target: "PAGE",
      action: "create",
      pathParams: {
        projectID: this.projectService.getProjectId(),
        pageName: params.pageName
      },
      data: {
        "pageType": params.pageType,
        "pageTitle": params.pageTitle,
        "includedPageTypes": params.includedPageTypes,
        "templateName": params.templateName,
        "override": params.override,
        "artifactVersion": {
          "artifactId": params.artifactId,
          "versionId": params.versionId
        }
      }
    })as Promise<any>)
  }

  update(params: any) {
    return this.wmHttpService.execute({
      target: "PAGE",
      action: "update",
      pathParams: {
        projectID: this.projectService.getProjectId(),
        pageName: params.pageName
      },
      data: params.data
    });
  }

  list() {
    return (this.wmHttpService.execute({
      target: "PAGE",
      action: "list",
      pathParams: {
        projectID: this.projectService.getProjectId()
      }
    }) as Promise<any>).then((pages) => {
      this.pages = pages;
      return pages;
    });
  }

  remove(pageName: string) {
    return this.wmHttpService.execute({
      target: "PAGE",
      action: "remove",
      pathParams: {
        projectID: this.projectService.getProjectId(),
        pageName: pageName
      }
    });
  }


  rename(pageName: string, newPageName: string) {
    return this.wmHttpService.execute({
      target: "PAGE",
      action: "rename",
      pathParams: {
        projectID: this.projectService.getProjectId(),
        pageName: pageName
      },
      data: newPageName
    });
  }

  duplicate(pageName: string, newPageName: string) {
    return this.wmHttpService.execute({
      target: "PAGE",
      action: "duplicate",
      pathParams: {
        projectID: this.projectService.getProjectId(),
        pageName: pageName
      },
      data : newPageName
    });
  }

  // function to return page details from pages list
  getPageDetails(pageName: string) {
    return this.pages.find((page:any) => page.name === pageName);
  }

  // get activePageName
  getActivePageName() {
    return this.activePageName;
  }

  // to set activePageName locally
  setActivePageName(pageName: string) {
    this.activePageName = pageName;
  }

  getPages() {
    return get(this.projectService, 'projectDetails.pages');
  }

  fetchContent(url: string, options?: any) {
    if (!url.startsWith(environment.SERVICES_BASE_PATH)) {
      url = environment.SERVICES_BASE_PATH + url;
    }
    return new Promise((resolve, reject) => {
      this.http.get(url, options).subscribe({
        next: (v) => resolve(v),
        error: (e) => reject(e),
        complete: () => {}
      });
    });
  }
}
